import type { IUserRole } from '@/types/user'
import { DOCUMENT_TYPES } from './documents'
import { USER_ROLES } from './users'

export const CONTEXT_DOCUMENT_INGESTION_STATUS = {
  PENDING: 'pending' as const,
  INDEXED: 'indexed' as const,
  FAILED: 'failed' as const,
} as const

export type IContextDocumentIngestionStatus =
  (typeof CONTEXT_DOCUMENT_INGESTION_STATUS)[keyof typeof CONTEXT_DOCUMENT_INGESTION_STATUS]

export const CONTEXT_DOCUMENT_TYPES = [
  DOCUMENT_TYPES.POLICY,
  DOCUMENT_TYPES.PROCEDURE,
  DOCUMENT_TYPES.REGISTER,
  DOCUMENT_TYPES.DOCUMENT,
] as const

export type IContextDocumentType = (typeof CONTEXT_DOCUMENT_TYPES)[number]

export const CONTEXT_DOCUMENT_ALLOWED_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.csv',
  '.txt',
  '.md',
  '.html',
] as const

export const CONTEXT_DOCUMENT_INGESTION_REASONS = {
  TIMEOUT: 'CONTEXT_DOCUMENTS.INGESTION_TIMEOUT',
  ERROR: 'CONTEXT_DOCUMENTS.INGESTION_ERROR',
} as const

export const CONTEXT_DOCUMENT_STALE_MONTHS = 12
export const CONTEXT_DOCUMENT_PENDING_TIMEOUT_HOURS = 24
export const CONTEXT_DOCUMENT_STORE_FOLDER = 'context'
export const CONTEXT_DOCUMENT_SOURCE = 'context'
export const CONTEXT_DOCUMENTS_ROUTE = '/suppliers/context-documents'
export const CONTEXT_DOCUMENTS_DOWNLOAD_PARAM = 'download'
export const CONTEXT_DOCUMENTS_POLL_INTERVAL_MS = 15_000

// External read-only roles: they can browse and download the hub but never change it or own a document.
export const CONTEXT_DOCUMENTS_READ_ONLY_ROLES: readonly IUserRole[] = [USER_ROLES.AUDITOR]

export const CONTEXT_DOCUMENT_ERRORS = {
  NOT_FOUND: 'Context document not found',
  FILE_MISSING: 'Context document file is missing from the store',
  INVALID_OWNER: 'The selected owner cannot own context documents',
  INVALID_ID: 'Invalid context document ID',
  INVALID_FIELDS: 'Invalid or missing context document fields',
} as const
